import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, Brain } from 'lucide-react';

interface AIProcessingAnimationProps {
  title: string;
  description: string;
}

const AIProcessingAnimation: React.FC<AIProcessingAnimationProps> = ({ title, description }) => {
  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      exit={{ opacity: 0, scale: 0.9 }}
      className="absolute inset-0 bg-white/95 backdrop-blur-sm flex items-center justify-center z-50 rounded-lg"
    >
      <div className="bg-white rounded-lg shadow-xl p-8 max-w-md w-full mx-4">
        <div className="flex flex-col items-center">
          <div className="relative w-24 h-24 mb-6">
            <motion.div
              className="absolute inset-0 flex items-center justify-center"
              animate={{ rotate: 360 }}
              transition={{ duration: 8, repeat: Infinity, ease: "linear" }}
            >
              <Sparkles className="text-[#9b87f5] h-8 w-8" />
            </motion.div>
            
            <motion.div
              className="absolute inset-0 flex items-center justify-center"
              initial={{ scale: 0.6 }}
              animate={{ scale: [0.6, 1, 0.6] }}
              transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
            >
              <Brain className="text-[#7662DA] h-12 w-12" />
            </motion.div>
            
            <motion.div
              className="absolute inset-0 flex items-center justify-center rounded-full"
              style={{ border: '2px dashed #9b87f5' }}
              animate={{ rotate: -360 }}
              transition={{ duration: 12, repeat: Infinity, ease: "linear" }}
            />
          </div>
          
          <h3 className="text-xl font-bold text-[#1A1F2C] mb-2">{title}</h3>
          <p className="text-[#1A1F2C]/70 text-center">{description}</p>
          
          <div className="mt-6 flex items-center space-x-2">
            <motion.div
              animate={{ y: [-3, 3, -3] }}
              transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut" }}
              className="w-2 h-2 bg-[#9b87f5] rounded-full"
            />
            <motion.div
              animate={{ y: [-3, 3, -3] }}
              transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut", delay: 0.2 }}
              className="w-2 h-2 bg-[#9b87f5] rounded-full"
            />
            <motion.div
              animate={{ y: [-3, 3, -3] }}
              transition={{ duration: 1.5, repeat: Infinity, ease: "easeInOut", delay: 0.4 }}
              className="w-2 h-2 bg-[#9b87f5] rounded-full"
            />
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default AIProcessingAnimation;
